<template>
  <div class="top">
    <div>
        基于传统的技术分析方法出的买卖点，都是右侧信号，有明显的滞后性。
    </div>
    <div>
        <common-data name="appShortName_26" v-common-display/>提供左侧的价格研究方法！原创的多因子估值算法，基于左侧交易逻辑，对引起股票价格变化的多个因子数据项进行深度加工，为投资者提供一个寻找左侧买卖点的研究工具。判断一只股票现在处于高位还是低位，现在是合适的买点？现在是合适的卖点？为你提供重要参考。
    </div>
    <div>
        投资是一个机遇，也是一个风险。选股固然重要，买到上涨的股票才能产生利润，但是也要控制好风险，避开有风险的股票也同样重要！软件提供基于财务分析的个股风险研究工具，能够分析企业的盈利质量，发现企业的潜在经营风险，未雨绸缪，避免踩雷买到风险股。
    </div>
    <div>
        软件还提供原创的股息率统计算法，支持基于分红数据的一种另类投资方法。
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.top div{
    color: #292929;
    text-indent: 2em;
    font-size: 15px;
    padding: 5px 0;
    line-height: 24px;
}
</style>